import React, {Component} from 'react';
import {inject, observer} from "mobx-react";
import {renderToString} from "react-dom/server";
import moment from "moment";
import {api} from "../../../../services";
import Map from "../../../../common/components/Map";
import {
  MarkerEmptyIcon,
  MarkerOverRpmIcon,
  MarkerTripEndIcon,
  MarkerTripStartIcon
} from "../../../../common/icons";
import hereHelper from "../../../../helpers/hereHelper";
import HereService from "../../../../services/Here";

import './TripDetail.css'

export default class TripMap extends Component
{
  constructor(props) {
    super(props);
    this.MapRef = React.createRef();

    this.MarkerEmptyIcon = renderToString(<MarkerEmptyIcon />);
    this.TripStartIcon = renderToString(<MarkerTripStartIcon style={{ color: 'var(--engine-on)' }} />);
    this.TripEndIcon = renderToString(<MarkerTripEndIcon style={{ color: 'var(--engine-off)' }} />);
    this.OverRpmIcon = renderToString(<MarkerOverRpmIcon />);

    this.state = {
      address1: '',
      address2: '',
      hasValidPosition: true,
      positions: [],
      overRpmsWithPositions: []
    };
  }

  matchroute() {
    if (this.props.trip && this.props.trip.positions && this.props.trip.positions.length > 0) {
      const positions = this.props.trip.positions.map(position => position.loc)
      this.setState({ positions: positions });

      const gpx = hereHelper.buildGpxForMatchroute(positions);
      return new HereService()
        .matchroute(gpx)
        .then(hereHelper.getPositionsFromMatchrouteResponse)
        .then(positions => new Promise(resolve => this.setState({ positions }, resolve)));
    } else {
      return new Promise(resolve => this.setState({ positions: [] }, resolve));
    }
  }

  loadRpms = () => {
    const { startAt, endAt } = this.props.trip;
    api('getRpm', this.props.trip.carId, moment(startAt).format('YYYY-MM-DD'), moment(endAt ? endAt : startAt).format('YYYY-MM-DD'))
      .then(rawOverRpms => {
        return rawOverRpms;
      })
      .catch(() => {})
      .then(rawOverRpms => {
        const overRpms = rawOverRpms.rpms.filter(rpm => rpm.startDateTime >= startAt && rpm.endDateTime <= endAt);
        let overRpmsWithPositions = overRpms;
        const positions = this.props.trip.positions.map(position => position.loc);
        overRpmsWithPositions = overRpmsWithPositions.map(overRpm => {
          const {
            coordinates: [startPosition_lng, startPosition_lat]
          } = overRpm.startPosition;
          const {
            coordinates: [endPosition_lng, endPosition_lat]
          } = overRpm.endPosition;
          return {
            ...overRpm,
            startPosition: { lat: startPosition_lat, lng: startPosition_lng },
            endPosition: { lat: endPosition_lat, lng: endPosition_lng }
          };
        });

        this.setState({
          overRpmsWithPositions
        });
      });
  }

  componentDidMount = () => {
    //current.wrappedInstance if the component is wrapped by the mobx injector
    this.MapInstace = this.MapRef.current.wrappedInstance;
    this.matchroute();
    this.loadRpms();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.trip !== this.props.trip) {
      this.matchroute();
      this.loadRpms();
    }
  };


  markersMapper = (marker, index) => {
    const [lng, lat] = marker.coordinates;
    let markerData = {
      icon: marker.theme === 'start' ? this.TripStartIcon : marker.theme === 'end' ? this.TripEndIcon : marker.theme === 'overrpm' ? this.OverRpmIcon : this.MarkerEmptyIcon,
      lng,
      lat,
      id: marker.id
    };
    return markerData;
  };

  render(){
    const { trip } = this.props;
    const { positions, overRpmsWithPositions } = this.state;

    let start = (positions && positions[0]) || [0, 0];
    let end = (positions && positions[positions.length - 1]) || [0, 0];

    let markers = [{ id: 0, theme: 'start', coordinates: start }, { id: 1, theme: 'end', coordinates: end }];
    overRpmsWithPositions.forEach(over => {
      const {
        startPosition: { lat, lng }
      } = over;
      markers.push({ id: markers.length, theme: 'overrpm', coordinates: [lng, lat] });
    });

    return(
      <Map
        getLat={location => location.coordinates[1]}
        getLng={location => location.coordinates[0]}
        ref={this.MapRef}
        onTap={() => false}
        className="tripDetailMap"
        style={{
          height: '100%',
          right: '0',
          width: '100%'
        }}
        markers={markers}
        markersMapper={this.markersMapper}
        polyline={positions.length > 1 ? positions.map(([lng, lat]) => ({ lng, lat })) : markers.map(this.markersMapper)}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripDetail/TripMap.js